import { Drawer } from '@vrplatform/components-legacy';
import { hasValue } from '@vrplatform/utils';
import { useState } from 'react';
import { useAutomationHistoryDrawer } from '../../hooks';
import { MultiWorkflowOverview } from './MultiWorkflowOverview';
import { SingleWorkflow } from './SingleWorkflow';

const previewMaxWidth = 1100;

export const AutomationHistoryDrawer = () => {
  const { close, syncIds, activeDrawer } = useAutomationHistoryDrawer();

  const opened = !!activeDrawer && activeDrawer === 'workflows';
  const ids = syncIds?.filter(hasValue) || [];

  return (
    <Drawer
      opened={opened}
      zIndex={101}
      onClose={close}
      size={previewMaxWidth}
      containerSx={{
        marginRight: 20,
        borderRadius: 20,
        padding: 0,
      }}
    >
      <Content syncIds={ids} closeDrawer={close} />
    </Drawer>
  );
};

const Content = ({
  closeDrawer,
  syncIds,
}: {
  syncIds: string[];
  closeDrawer: () => void;
}) => {
  const [activeWorkflowId, setActiveWorkflowId] = useState<string | null>(null);

  const isOneWorkflow = syncIds.length === 1;

  if (isOneWorkflow || activeWorkflowId)
    return (
      <SingleWorkflow
        syncId={activeWorkflowId || syncIds[0]}
        hasMultiple={syncIds.length > 1}
        closeDrawer={closeDrawer}
        resetActiveSyncId={() => setActiveWorkflowId(null)}
      />
    );

  if (!syncIds.length) return null;

  return (
    <MultiWorkflowOverview
      syncIds={syncIds}
      closeDrawer={closeDrawer}
      setWorkflowId={setActiveWorkflowId}
    />
  );
};
